import React, { forwardRef } from 'react';
import { Platform } from 'react-native';
import { Link } from '@/lib/navigation';
import { nativePublicPagePath, openPublicPage } from '@/lib/openPublicPage';
import { useToastStore } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';

// Preserve Expo's Link/Slot and web anchor semantics. Only native destinations
// known to redirect home are intercepted, before Expo changes navigation state.
const PublicPageLink = forwardRef(function PublicPageLink({ href, onPress, ...props }, ref) {
  const { t } = useTranslation();
  const { addToast } = useToastStore(state => state.actions);
  const path = Platform.OS === 'web' ? null : nativePublicPagePath(href);
  const press = path ? async event => {
    onPress?.(event);
    if (event?.defaultPrevented) return;
    event.preventDefault();
    try { await openPublicPage(path); }
    catch (_) { addToast(t('settings.help.linkError'), 'error'); }
  } : onPress;
  return <Link {...props} ref={ref} href={href} {...(press && { onPress: press })} />;
});
export default PublicPageLink;
